// The guided tour of Laptops, for the HR and admin people who make sure
// everyone on Ops has a laptop. Steps point at [data-tour] anchors on LaptopsPage.

export const LAPTOPS_TOUR_ID = 'laptops';

export const laptopsTourSteps = [
  {
    title: 'Laptops',
    target: '[data-tour="page-header"]',
    body: [
      'Everyone on Ops with the laptop assigned to them, checked against PDQ Connect, which reports every laptop and who last signed in to it.',
      'Use Next to walk through, or Skip if you would rather explore. Either way it will not pop up again; the ? by the title replays it.',
    ],
  },
  {
    title: 'PDQ Connect',
    target: '[data-tour="pdq-sync"]',
    body: [
      'Ops pulls PDQ\'s devices every six hours. This line says when it last did and how many devices it saw, or why it failed. Sync with PDQ now pulls them straight away, for example after a new laptop has been enrolled.',
      'PDQ never assigns a laptop by itself. It suggests one, and you decide.',
    ],
  },
  {
    title: 'What needs doing',
    target: '[data-tour="tiles"]',
    body: [
      'The counts lead with the people who have no laptop, how many of them PDQ has a suggestion for, and how many need a look: a laptop somebody else is signing in to, one PDQ has not seen for 30 days, or one that is not in PDQ at all. Click a count to filter the list to it. The unassigned count jumps to the laptops nobody holds.',
      'Accept all suggestions assigns every suggested laptop in one go. Anything that has changed since the page loaded is skipped and named, not forced.',
    ],
  },
  {
    title: 'The list',
    target: '[data-tour="roster"]',
    body: [
      'One row per person still with the company: their laptop\'s asset tag, its model, when PDQ last saw it, and its status. A suggested laptop shows with a question mark. Filter by status, or search by name, team, asset tag or serial number.',
    ],
  },
  {
    title: 'Assigning a laptop',
    target: '[data-tour="roster"]',
    body: [
      'Click a row to open the person\'s panel. Assign the laptop PDQ suggests with one click, choose another from PDQ (the laptops they sign in to come first), or type an asset tag for one PDQ does not know.',
      'If the laptop you choose is somebody else\'s, the panel asks before moving it. Assigning a new laptop records the old one as returned, and the panel keeps the history.',
      'Laptop handed back records a return. Somebody who does not need a laptop from us, a contractor on their own kit say, can be marked with the reason, so they stop counting as missing.',
    ],
  },
  {
    title: 'Unassigned laptops',
    target: '[data-tour="unassigned"]',
    body: [
      'Every laptop nobody on Ops holds: one handed back, one PDQ reports that nobody has, and one added here by asset tag before it is enrolled in PDQ. A laptop PDQ suggests for somebody, or one still with a leaver, is dealt with elsewhere on the page.',
      'Set each one\'s state so the team knows what it is waiting for: Spare (ready to issue), In repair, or Retired (disposed of, lost or written off, and kept off the list). A handed-back laptop starts as Not sorted until somebody looks at it.',
      'Give out assigns it to a person, people with no laptop first, and clears its state. Add a laptop puts a new one on the list as a spare before it is built: give it its asset tag here, name it with that tag when you build it, and it links to PDQ once it enrols.',
    ],
  },
  {
    title: 'Laptops with leavers',
    target: '[data-tour="recover"]',
    body: [
      'Laptops still assigned to somebody who has left, or last signed in to by a leaver according to PDQ, are listed at the bottom so they can be recovered. Record as returned closes an assignment; a laptop known only from PDQ drops off once it is assigned to somebody else.',
      'The onboarding Laptop Set Up step assigns the laptop it records, and the offboarding Assets Returned step records it as returned, so most of this keeps itself up to date.',
      'A person\'s laptop also shows on their profile on the People page, in the Laptop tab, with a button that opens this page on them.',
    ],
  },
];
